<template>
  <div class="main-content-container container-fluid px-4">
    <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="dalert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
      <i class="fa fa-info mx-2"></i>
      <span id="warning">{{ error_msg }}</span> 
    </d-alert>
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">List</span>
        <h3 class="page-title">Donasi</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-body border-bottom">
              <div class="row" style="margin:auto">
                 <div class="form-group col-md-12" style="font-weight:bold">Upload Excel Donasi</div>
              </div>
              <div class="row">
                 <div class="form-group col-md-12">
                   <html-preview :donations.sync="donations" :errors.sync="errors"/>
                 </div>
              </div>
              <div class="row">
                 <div class="form-group col-md-12">
                   <div style="padding-left:.7em">
                     Total donations : {{ filtered_donations.length }} <br/>
                     Total errors : {{ errors.length }}
                   </div>
                 </div>
              </div>
              <div class="row">
                 <div class="form-group col-md-12" v-if="errors.length">
                   <div style="padding-left:.7em">
                     {{ errors[0].title }} ,
                     {{ errors[0].name }}
                   </div>
                 </div>
              </div>
              <div class="row">
                 <div class="form-group col-md-12" v-if="filtered_errors.length">
                   <div style="padding-left:.7em" v-for="(item, idx) in filtered_errors" :key="idx">
                     {{ item }}
                   </div>
                 </div>
              </div>
              <section v-if="donations.length && !errors.length && !filtered_errors.length">
                <button type="button" class="btn-primary btn-sm" @click="upload_xls(1)" style="padding:0.15rem 0.5rem !important;margin-right:.2rem;">Upload Donasi</button>
              </section>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
             <!--d-button type="button" :disabled="loading" class="btn-accent" @click="add_new" data-toggle="tooltip" data-placement="top" title="Add New" ><i class="material-icons">note_add</i> Tambah Baru</d-button-->
              &nbsp;
              <button type="button" class="btn-primary btn-sm" @click="xls(0)" style="padding:0.15rem 0.5rem !important;margin-right:.2rem;">List Bulanan</button>
              <button type="button" class="btn-primary btn-sm" @click="xls(1)" style="padding:0.15rem 0.5rem !important;margin-right:.2rem;">List Tahunan</button>
              <d-datepicker v-model.trim="ddate"></d-datepicker> &nbsp;
          </div>
          <div class="card-body p-0 pb-3 text-center" style="overflow-x:scroll">
            <d-row style="margin:auto">
            <d-col md="4"  class="form-group" style="text-align:left">
              Menampilkan 
              <select v-model="ipp" >
                <option value=5 selected>5 item</option>
                <option value=10>10 item</option>
                <option value=15>15 item</option>
                <option value=20>20 item</option>
              </select>          
              &nbsp;&nbsp;
            </d-col>
            <d-col md="4"  class="form-group">
            </d-col>
            <d-col md="4"  class="form-group">
              <d-form-input type="text" id="feInputAddress" placeholder="Cari" v-model.trim="search" />
            </d-col>
            </d-row>
            <d-row>
            </d-row>
        <b-table
            :data="isEmpty ? [] : data"
            :loading="loading"
            :mobile-cards="hasMobileCards"
            paginated
            backend-pagination
            :total="total"
            :per-page="perPage"
            :current-page="page"
            @page-change="onPageChange"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"

            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"            
            >

            <template slot-scope="props">
                <b-table-column field="id" label="Id" sortable>
                    <span class="tag is-success">
                    {{ props.row.id }}
                    </span>
                    <button v-if="props.row.void==0" type="button" class="btn-danger btn-sm" @click="void_data(props.row.id)" style="padding:0.15rem 0.5rem !important"><i class="material-icons" alt="void">clear</i></button>
                    <button v-if="props.row.void==0" type="button" class="btn-primary btn-sm" @click="open_wa(props.row)" style="padding:0.15rem 0.5rem !important">WA</button>
                </b-table-column>
                <b-table-column field="idnumber" label="No ID" sortable>
                    {{ props.row.idnumber }}
                </b-table-column>
                <b-table-column field="rcptnumber" label="No Td Terima" sortable>
                    {{ props.row.rcptnumber }}
                </b-table-column>
                <b-table-column field="fullname" label="Nama Lengkap" sortable>
                    {{ props.row.fullname }}
                </b-table-column>
                <b-table-column field="mobile_phone" label="HP" sortable>
                    {{ props.row.mobile_phone }}
                </b-table-column>
                <b-table-column field="created_at" label="Tgl buat" sortable>
                    {{ props.row.created_at }}
                </b-table-column>
                <b-table-column field="transdate" label="Tgl transaksi" sortable>
                    {{ props.row.transdate }}
                </b-table-column>
                <b-table-column field="amount" label="Nilai" style="text-align:right" sortable>
                    {{ new Intl.NumberFormat().format(props.row.amount) }}
                </b-table-column>
                <b-table-column field="paymethod" label="Metode"  sortable>
                    {{ props.row.paymethod }}
                </b-table-column>
                <b-table-column field="created_by" label="Dibuat oleh" sortable>
                    {{ props.row.created_by }}
                </b-table-column>
                <b-table-column field="void" label="Status" sortable>
                    {{ props.row.void==1? "Void":"" }}
                </b-table-column>
                <b-table-column field="created_by" label="Divoid oleh">
                    {{ props.row.voided_by }}
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Tidak ada data.</p>
                    </div>
                </section>
            </template>
        </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../env.vue';
import FileSaver from 'file-saver'

    export default {

        data() {
            return {
                filtered_donations:[],
                filtered_errors:[],
                donations:[],
                errors:[],
                file:null,
                selectedSheet:0,
                ddate:'',
                show_alert:false,
                data:[],
                list:[],
                error_msg:'',
                index:0,
                isEmpty: false,
                isHoverable: true,
                loading: false,
                hasMobileCards: true,
                sortField:'id',
                sortOrder:'asc',
                sortIcon:'arrow-up',
                sortIconSize:'is-small',
                sort:'name',
                defaultSortOrder:'asc',
                page:1,
                perPage:5,
                total:2,
                filename:'',
                ipp:5,
                search:'',
                categories:[
                 { value: 1, text:'GKY' },
                 { value: 2, text:'Non GKY' },
                 { value: 3, text:'Institusi' },
                ],
            }
        },
        watch:{
          donations(){
            let arr=[];
            this.filtered_errors=[];
            for(let i=0; i<this.donations.length; i++){
                if (parseInt(this.donations[i].amount)<=0) continue;
                this.donations[i].name= this.donations[i].name.trim().replace(/\s+/g,' ').replace(/\.$/,'')
                this.donations[i].transdate=this.convertDate(this.donations[i].transdate);
                this.donations[i].prefix= this.donations[i].prefix.trim().replace(/\s+/g,' ').replace(/\.$/,'')
                if (this.donations[i].transdate==-1) 
                    this.filtered_errors.push( 'Donasi '+this.donations[i].name+' format tanggalnya salah' );
                arr.push(this.donations[i]);
            }
            if (this.filtered_errors.length>0) return;
            this.loading=true;
            for(let i=0; i<arr.length; i++){
              arr[i].prefix=arr[i].prefix+' '+arr[i].name;
              arr[i].prefix=arr[i].prefix.trim().replace(/\s+/g,' ')
            }
console.log('arr',arr);
            this.axios.post( env.server+'/donation/check',{
               donations:this.donations,
            }).then(
              resp=>{
                 this.loading=false;           
                 this.filtered_errors=[];
                 if (resp.data.length){
                    let err='';
                    let dcount='';
                    resp.data=JSON.parse(resp.data);
                    console.log(resp.data.data);
                    resp.data=resp.data.data
                    for( let j=0; j<resp.data.length; j++){
                      err='';
                      err=resp.data[j].name;
                      dcount=resp.data[j].count;
                      if ( dcount>1 ) err='Nama '+err+' ada lebih dari 1';  
                      else err='Nama '+err+' tidak ditemukan';
                      this.filtered_errors.push(err);
                    }
                 }
                 this.filtered_donations=arr;
            })
          },
          ipp(){
           if (this.ipp>0) this.perPage=this.ipp*1
           else this.perPage=this.total*1
           this.update_data();
          },
          search(){
           if(parseInt(this.search)>0||this.search.length>3||!this.search.length)this.update_data()
          },
        },
        methods:{
          convertDate(dstr){
//            console.log('convertdate',dstr);
            let tmp = dstr.toLowerCase().trim().replace(/\-|\//g,' ').replace(/\s+/g,' ').split(' ');
            let month=0;
            switch(tmp[1].substr(0,3)){
              case '01':
              case '1':
              case 'jan': month=1;break;
              case '02':
              case '1':
              case 'peb':
              case 'feb': month=2;break;
              case '03':
              case '3':
              case 'mar': month=3;break;
              case '04':
              case '4':
              case 'apr': month=4;break;
              case '05':
              case '5':
              case 'mei':
              case 'may': month=5;break;
              case '06':
              case '6':
              case 'jun': month=6;break;
              case '07':
              case '7':
              case 'jul': month=7;break;
              case '08':
              case '8':
              case 'agu': 
              case 'aug': month=8;break;
              case '09':
              case '9':
              case 'sep': month=9;break;
              case '10':
              case 'okt':
              case 'oct': month=10;break;
              case '11':
              case 'nop':
              case 'nov': month=11;break;
              case '12':
              case 'des':
              case 'dec': month=12;break;
            }
//            console.log('convertdate',tmp[0]+'-'+month+'-'+tmp[2]);
            if (month==0)return -1
            let d = new Date(tmp[2]+'-'+month+'-'+tmp[0]);
            let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
            let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d)
            let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)          
            let ddate = `${ye}-${mo}-${da}`;
            return ddate;
          },

          onChange(event) {
              this.file = event.target.files ? event.target.files[0] : null;
          },

          open_wa(obj){
/*
            let pref='';
            if (obj.gender==1) pref='Bpk';
            if (obj.gender==2) pref='Ibu';
            let strm="Terima kasih untuk donasi yg diberikan "+pref+' '+obj.fullname;
            window.open("https://wa.me/"+obj.mobile_phone+"?text="+encodeURI(strm))
*/
           let res='';
           do {
              res=confirm('Pesan WA otomatis dikirim maks 1 menit setelah donasi dibuat,\napakah mau mengirim pesan WA sekali lagi ?');
           } while( res==='')
           if (!res)return;
           this.loading=true;           
           this.axios.post( env.server+'/donation/resend/'+obj.id,{
           }).then(
             resp=>{
                this.loading=false;           
           })

          },

          void_data(id){
           let res='';
           do {
              res=confirm('Void transaksi ?');
           } while( res==='')
           if (!res)return;
           this.loading=true;           
           this.axios.post( env.server+'/donation/void/'+id,{
           }).then(
             resp=>{
                this.save_state();
                for (var i=0; i<this.data.length; i++ ){
                 if ( this.data[i].id==id ) this.data[i].void=1;
                }
                this.loading=false;           
           })
          },

          find_category(cat){
            let resp= this.categories.filter( c=>c.value==cat ) 
            return resp[0].text;
          },

          save_state(){
            var arr={
              page:this.page,
              perPage:this.perPage,
              total:this.total,
              ipp:this.ipp,
              search:this.search,
              sortField:this.sortField,
              sortOrder:this.sortOrder,
            };
            this.$store.commit('list',arr);
          },

          load_state(){
            var arr=this.$store.state.list;
            if ( arr==null ) return;
            this.page=arr.page;
            this.perPage=arr.ipp>0 ? arr.perPage : arr.total;
            this.total=arr.total;
            this.ipp=arr.ipp;
            this.search=arr.search;
            this.sortField=arr.sortField;
            this.sortOrder=arr.sortOrder;
          },

          onPageChange(page){
           this.page=page;
           this.update_data();           
          },

          onSort(field,order){
           if ( !this.loading ){           
            this.sortField=field;
            this.sortOrder=order;
            this.update_data();
           }
          },

          pop_alert(msg){
            if (msg==undefined) return;
            this.$refs.dalert.dismissed=false;
            this.show_alert=5;
            this.error_msg=msg;
          },

          upload_xls(m){
            if (this.filtered_donations.length==0 || this.filtered_errors>0 
                || this.errors.length>0) {
                alert('Harap periksa file xls yg mau diupload');
                return;
            }
            this.loading=true;
            this.axios.post( env.server+'/donation/upload-xls-donations',{
               donations:this.donations,
            }).then(
              resp=>{
                this.loading=false;
                alert('Upload berhasil');
            });
          },

          xls(m){
           var file='';
           this.loading=true;           
           var d= new Date();
           var report_date=d.getDate()+'-'+(d.getMonth()+1)+'-'+d.getFullYear();
           this.filename = 'donasi_' + report_date + '.xlsx';
           this.save_state();
           var url=env.server+'/donation-list/excel',
           dsearch = this.search;
           let dtfilter='';
           let  tmpd=this.ddate.split('-');
           if (m==1){
             dtfilter=tmpd[0];
           } else {
             dtfilter=tmpd[0]+'-'+tmpd[1].padStart(2,"0")+'-';
           }
           this.axios.post( url,{
             start: parseInt(m),
             length: 0,
             sort: dsearch,
             sort_order: '',
             scfilter:dtfilter,
             todate: '',
             }, {
              responseType: 'arraybuffer',
              headers: {
                Accept: 'application/octet-stream',
             }
             }).then(
             resp=>{
              this.loading = false;
              file = new Blob([resp.data], { type: 'application/octet-stream' });
              FileSaver.saveAs(file, this.filename);
             }
           );
          },
          update_data(){
           this.loading=true;           
           this.save_state();
           this.axios.post( env.server+'/donation-list',{
             start: this.page,
             length: this.perPage>0 ? this.perPage: this.total,
             sort: this.sortField,
             sort_order: this.sortOrder,
             scfilter: this.search,
             todate: '',
           }).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
               this.data=resp.data.data.items;
               this.total=resp.data.data.total_results;
               for (var i=0; i<this.data.length; i++ ){
                 this.data[i].idx=i;
                 let tmp=[];
                 tmp=this.data[i].transdate.split('-');
                 this.data[i].transdate=tmp[2]+'-'+tmp[1]+'-'+tmp[0];
               }
             }
           );
          },
        },
        mounted(){           
          var dt = new Date();
          this.ddate=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
          this.load_state();
          this.update_data();
        },
    }
</script>
